import { useMutation, UseMutationResult } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import {
	ProgrammeUserWithPermissionsRes,
	InviteUserToProgrammeDto,
} from '@dealstack/shared/lib/generated';

const inviteProgrammeUser = async ({
	programmeId,
	email,
	firstName,
	lastName,
	permissionRoles,
	isContactPerson,
	options,
}: { programmeId: string } & InviteUserToProgrammeDto) => {
	return await makeRequest<ApiV1.Response<ProgrammeUserWithPermissionsRes>>({
		endpoint: formatUnicorn(API_PATHS.MIP_PROGRAMMEID_USERS_POST, {
			programmeId,
		}),
		method: HTTP_METHOD.POST,
		body: JSON.stringify({
			email,
			firstName,
			lastName,
			permissionRoles,
			isContactPerson,
			options,
		}),
	});
};

export const useInviteProgrammeUser = (): UseMutationResult<
	ApiV1.Response<ProgrammeUserWithPermissionsRes>,
	unknown,
	{ programmeId: string } & InviteUserToProgrammeDto
> => {
	return useMutation({
		mutationFn: inviteProgrammeUser,
	});
};
